{
  "fr": {
    "paginator": {
      "labels": {
        "perPage": "Par Page",
        "pages": "%{page} sur %{total}"
      }
    }
  }
}
